import { BookOpen, Grid, Calendar, Book, Aperture, FilePlus, Settings, Users, MapPin, Cpu, Layers, HelpCircle, Video,People, Activity, Clipboard, UserCheck, Key, BarChart, Target, Award, PieChart, Table, FileText, User } from 'react-feather';
import { BiCctv } from 'react-icons/bi';
import { IoCameraOutline } from "react-icons/io5";
import { GoPeople } from "react-icons/go";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { GiCctvCamera } from 'react-icons/gi';
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

export const MENUITEMS = {
  'super-admin': [
    {
      Items: [
        {
          children: [],
        },

        { path: `${process.env.PUBLIC_URL}/dashboard/default`, icon: <Grid />, title: "Dashboard", activeTitle: 'default', type: "link" },
        { path: `${process.env.PUBLIC_URL}/dashboard/activitymonitor`, icon: <Aperture />, title: "Activity Monitor", activeTitle: 'activitymonitor', type: "link" },
        { path: `${process.env.PUBLIC_URL}/dashboard/permissions`, icon: <Key />, title: "Permissions", activeTitle: 'permissions', type: "link" },
        { path: `${process.env.PUBLIC_URL}/dashboard/role`, icon: <UserCheck />, title: "Role", activeTitle: 'role', type: "link" },
        { path: `${process.env.PUBLIC_URL}/dashboard/logs`, icon: <Book />, title: "Logs", activeTitle: 'logs', type: "link" }
      ],
    },
  ],
  'it-officer': [
    {
      Items: [
        {
          children: [],
        },
        { path: `${process.env.PUBLIC_URL}/dashboard/default`, icon: <Grid />, title: "Dashboard", activeTitle: 'default', type: "link" },
        { path: `${process.env.PUBLIC_URL}/dashboard/support`, icon: <HelpCircle />, title: "Support & Tickets", activeTitle: 'support', type: "link" },
      ],
    },
  ],
  'factory': [
    {
      Items: [

        //ibrahim fabrics menu
        { path: `${process.env.PUBLIC_URL}/dashboard/default`, icon: <Grid />, title: "Dashboard", activeTitle: 'default', type: "link" },
        { path: `${process.env.PUBLIC_URL}/dashboard/supportandtickets`, icon: <TfiHeadphoneAlt />, title: "Support & Tickets ", activeTitle: 'supportandtickets', type: "link" },
      ],
    },
  ],
  'global': [
    {
      Items: [
        { path: `${process.env.PUBLIC_URL}/dashboard/summary`, icon: <Grid />, title: "Summary", activeTitle: 'summary', type: "link" },
        { path: `${process.env.PUBLIC_URL}/dashboard/default`, icon: <Grid />, title: "Live Analytics", activeTitle: 'default', type: "link" },
        { path: `${process.env.PUBLIC_URL}/reports`, icon: <BarChart />, title: "AI Model & Reports", activeTitle: 'reports', type: "link" },
        { path: `${process.env.PUBLIC_URL}/areaanalysis`, icon: <PieChart />, title: "Area Owner Analysis", activeTitle: 'areaanalysis', type: "link" },
        { path: `${process.env.PUBLIC_URL}/sub-area-analysis`, icon: <Layers />, title: "Sub Area Analysis", activeTitle: 'sub-area-analysis', type: "link" },
        { path: `${process.env.PUBLIC_URL}/targets`, icon: <Target />, title: "Targets & Controls", activeTitle: 'targets', type: "link" },
        { path: `${process.env.PUBLIC_URL}/live_alerts`, icon: <Activity />, title: "Live Alerts", activeTitle: 'live_alerts', type: "link" },
        { path: `${process.env.PUBLIC_URL}/camera_configuration`, icon: <Aperture />, title: "Camera Status", activeTitle: 'camera_configuration', type: "link" },
        // created by sheheryar
        { path: `${process.env.PUBLIC_URL}/leaderboard`, icon: <Award />, title: "Leaderboard", activeTitle: 'leaderboard', type: "link" },
        { path: `${process.env.PUBLIC_URL}/support`, icon: <HelpCircle />, title: "Support & Tickets", activeTitle: 'support', type: "link" },
      ],
    },
  ],
  'area': [
    {
      Items: [
        {
          children: [],
        },
        { path: `${process.env.PUBLIC_URL}/dashboard/default`, icon: <Grid />, title: "Dashboard", activeTitle: 'default', type: "link" },
        { path: `${process.env.PUBLIC_URL}/reports`, icon: <BarChart />, title: "AI Model & Reports", activeTitle: 'reports', type: "link" },
        { path: `${process.env.PUBLIC_URL}/targets`, icon: <Target />, title: "Targets & Controls", activeTitle: 'targets', type: "link" },
        { path: `${process.env.PUBLIC_URL}/live_alerts`, icon: <BookOpen />, title: "Live Alerts", activeTitle: 'live_alerts', type: "link" },
        { path: `${process.env.PUBLIC_URL}/dashboard/camera_configuration`, icon: <Aperture />, title: "Camera Status", activeTitle: 'camera_configuration', type: "link" },
        { path: `${process.env.PUBLIC_URL}/dashboard/support`, icon: <HelpCircle />, title: "Support & Tickets", activeTitle: 'support', type: "link", },
      ],


    },
  ],
  'qa': [
    {
      Items: [
        {
          children: [],
        },
        { path: `${process.env.PUBLIC_URL}/dashboard/defaultqa`, icon: <Grid />, title: "Dashboard", activeTitle: 'default', type: "link" },
        { path: `${process.env.PUBLIC_URL}/support`, icon: <HelpCircle />, title: "Support", activeTitle: 'support', type: "link", },

      ],
    },
  ],
  'aitechqa': [
    {
      Items: [
        {
          children: [],
        },
        { path: `${process.env.PUBLIC_URL}/dashboard/defaultai`, icon: <Grid />, title: "Dashboard", activeTitle: 'default', type: "link" },
        { path: `${process.env.PUBLIC_URL}/support`, icon: <HelpCircle />, title: "Support", activeTitle: 'support', type: "link", },

      ],
    },
  ],
}



